import React, { useState, useEffect, useRef } from "react";

import { BlobToDownloadFile } from "../../../helper/commanFunction";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import { Pie, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReportJewelryReportService from "../../../services/reports-Jewelry-service";
import moment from "moment";
import DefaultImage from "../../../assets/images/icons/sampleimage.jpg";
import { Button, DatePicker, Modal, Select, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { chartColors } from "../colors";
import logoImg from "../../../assets/images/logo-img.png";

const { RangePicker } = DatePicker;
const initialEventState = {
  dealerID: "",
  forDealer: "",
  fromDate: moment().subtract(30, "days"),
  toDate: moment(),
  retailerIds: [],
  vendorIds: [],
  price: "",
  price1: "",
  price2: "",
};

const JewelryPriceReportMain = () => {
  const { t } = useTranslation();
  const JewelPriceChartRef = useRef();
  const { Option } = Select;

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [selectedData, setSelectedData] = useState(initialEventState);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [JewelryPriceTableList, setJewelryPriceTableList] = useState([]);
  const [selectedImage, setSelectedImage] = useState();
  const [visible, setVisible] = useState(false);
  const [defaultVisible, setDefaultVisible] = useState(false);
  const [showChart, setShowChart] = useState(false);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [priceRange, setPriceRange] = useState([]);
  const [topPriceTotal, setPriceTotal] = useState([]);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [key, setKey] = useState(true);
  const [sortOrderType, setsortOrderType] = useState("desc");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [dealerMembershipType, setDealerMembershiptype] = useState("");
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);

  // Add max entries constant
  const MAX_ENTRIES = 25; // limit the number of slices

  // Add state for processed chart data
  const [processedChartData, setProcessedChartData] = useState([]);
  const [googleChartData, setGoogleChartData] = useState([]);
  const [colorData, setColorData] = useState([]);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
          setDealerMembershiptype(
            loginDetials?.loginDetials?.responseData?.dealerMemberTypeName
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (selectedData.price1) {
      setPageNo(1);
      setPageSize(15);
      handleGetTableChartData(dealerId, selectedData.forDealer);
    } else if (selectedData.price === "Call for Price") {
      setPageNo(1);
      setPageSize(15);
      handleGetTableChartData(dealerId, selectedData.forDealer);
    }
  }, [selectedData]);

  // Prepare chart data with max entries limit
  const prepareChartData = (priceRanges, counts) => {
    const total = counts.reduce((a, b) => a + Number(b), 0);

    // Pair labels and data together
    const labeledData = priceRanges.map((label, idx) => ({
      label,
      value: Number(counts[idx]),
      percent: total > 0 ? (Number(counts[idx]) / total) * 100 : 0,
    }));

    // Sort descending by value
    const sorted = [...labeledData].sort((a, b) => b.value - a.value);

    // Split top and remaining
    const topData = sorted.slice(0, MAX_ENTRIES);
    const remainingData = sorted.slice(MAX_ENTRIES);

    // Sum "Others"
    const othersValue = remainingData.reduce((sum, d) => sum + d.value, 0);

    // If there are remaining values, push an "Others" slice
    if (othersValue > 0) {
      topData.push({
        label: t("Others"),
        value: othersValue,
        percent: total > 0 ? (othersValue / total) * 100 : 0,
      });
    }

    // Prepare rows for Google Chart
    const rows = [["Label", "Value"]];
    topData.forEach((item) => {
      const labelWithPercent = `${item.label} (${item.percent.toFixed(2)}%)`;
      rows.push([labelWithPercent, item.value]);
    });

    // Assign consistent colors
    const colors = topData.map((_, i) => chartColors[i % chartColors.length]);

    return { chartData: rows, colors, processedData: topData };
  };

  const handleGetForDealer = (id) => {
    try {
      const initialEventState = {
        dealerID: id,
      };
      setShowLoader(true);
      ReportJewelryReportService.GetForDealer(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            let forDealerValue;
            if (
              loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
                "Vendor" ||
              loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
                "VendorDiamond"
            ) {
              forDealerValue = 1;
            } else if (
              loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
                "Retailer" ||
              loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
                "Combined"
            ) {
              forDealerValue = 2;
            } else {
              forDealerValue = 3;
            }
            setSelectedData((prevState) => ({
              ...prevState,
              forDealer: responseData.forDealer,
            }));
            handleGetVendorDropdownData();
            handleGetRetailerDropdownData();
            handleGetPriceColumnData(id, forDealerValue);
            handleGetTableChartData(id, forDealerValue);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetVendorDropdownData = () => {
    try {
      const dealerId = loginDetials.loginDetials.responseData.dealerId;
      let inputData = {
        dealerId: dealerId,
        reporttype: "Dealer",
      };
      ReportJewelryReportService.GetVendorDropdownList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setVendorList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetRetailerDropdownData = () => {
    try {
      const dealerId = loginDetials.loginDetials.responseData.dealerId;
      let inputData = {
        dealerId: dealerId,
        reporttype: "Dealer",
      };
      ReportJewelryReportService.GetRetailerDropdownList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setRetailerList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetPriceColumnData = (DealerId, forDealerId) => {
    try {
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId.toString(),
        fromDate: selectedData.fromDate,
        toDate: selectedData.toDate,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
        reporttype: "Dealer",
      };
      setShowLoader(true);
      ReportJewelryReportService.GetClicksBasedOnPrice(inputData).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.Table;
          if (message === "Success") {
            let priceRange = [];
            let total = [];
            let showResp = responseData.every((element) => {
              return element.total === "0";
            });
            setShowChart(showResp);
            for (let i of responseData) {
              if (i.total !== 0) {
                priceRange.push(i.Range);
                total.push(i.total);
              }
            }

            // Use the new prepareChartData function
            const { chartData, colors, processedData } = prepareChartData(priceRange, total);

            var JewelVendorYAxisList = responseData.map((item) => {
              return parseInt(item.total);
            });
            var totalValueForPercentage = JewelVendorYAxisList.reduce(
              (a, b) => a + b,
              0
            );
            setTotalValueForPercentage(totalValueForPercentage);
            setPriceTotal(total);
            setPriceRange(priceRange);
            setColorData(colors);
            setGoogleChartData(chartData);
            setProcessedChartData(processedData);
            setShowLoader(false);
            setKey(!key);
          } else {
            setShowLoader(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const [totalCount, setTotalCount] = useState(0);

  const handleGetTableChartData = (
    DealerId,
    forDealerId,
    pageNumber,
    pageSize,
    sortColumn,
    sorttype
  ) => {
    try {
      let forDealerValue;
      if (
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Vendor" ||
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "VendorDiamond"
      ) {
        forDealerValue = 1;
      } else if (
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Retailer" ||
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Combined"
      ) {
        forDealerValue = 2;
      } else {
        forDealerValue = 3;
      }
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerValue.toString(),
        fromDate: selectedData.fromDate,
        toDate: selectedData.toDate,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
        category: "",
        metalType: "",
        metalColorType: "",
        price: selectedData.price,
        price1: selectedData.price1.toString(),
        price2: selectedData.price2.toString(),
        vendor: "",
        retailer: "",
        pageIndex: pageNumber ? pageNumber : 1,
        pageSize: pageSize ? pageSize : 15,
        sortColumnName:
          sortColumn === "UserIPAddress"
            ? "UserIPAddress"
            : sortColumn === "vendorName"
            ? "VendorName"
            : sortColumn === "retailerName"
            ? "RetailerName"
            : sortColumn === "collectionNew"
            ? "CollectionNew"
            : sortColumn === "category"
            ? "Category"
            : sortColumn === "date"
            ? "Date"
            : sortColumn === "styleNumber"
            ? "StyleNumber"
            : sortColumn === "metalType"
            ? "MetalType"
            : sortColumn === "metalColor"
            ? "MetalColor"
            : sortColumn === "price"
            ? "Price"
            : "date",
        sortOrder: sorttype ? sorttype.toString() : sortOrderType.toString(),
        reporttype: "Dealer",
      };
      setShowTableLoader(true);
      ReportJewelryReportService.GetJewelryTableChartData(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setJewelryPriceTableList(responseData);
            setShowTableLoader(false);
            setTotalCount(responseData?.[0]?.totalRecords || 0);
          } else {
            setTotalCount(0);
            setJewelryPriceTableList([]);
            setShowTableLoader(false);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setShowTableLoader(false);
          console.log(error);
        });
    } catch (error) {
      setTotalCount(0);
      console.log(error);
      setShowTableLoader(false);
    }
  };

  const imageClickHandler = (img) => {
    setVisible(true);
    setSelectedImage(img);
  };

  const handleApplyFilter = () => {
    setPageNo(1);
    setPageSize(15);
    var obj = selectedData;
    obj["price"] = "";
    obj["price1"] = "";
    obj["price2"] = "";

    handleGetForDealer(dealerId);

    setIsApplyFilter(!isApplyFilter);
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedData((prevState) => ({
        ...prevState,
        fromDate: moment.utc(dates[0]).toISOString(),
        toDate: moment.utc(dates[1]).toISOString(),
      }));
    }
  };

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      let forDealerValue = "";
      if (
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Vendor" ||
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "VendorDiamond"
      ) {
        forDealerValue = 1;
      } else if (
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Retailer" ||
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Combined"
      ) {
        forDealerValue = 2;
      } else {
        forDealerValue = 3;
      }
      const inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealerValue.toString(),
        fromDate: selectedData.fromDate,
        toDate: selectedData.toDate,
        retailerIds: selectedData.retailerIds.toString(),
        vendorIds: selectedData.vendorIds.toString(),
        category: "",
        metalType: "",
        metalColorType: "",
        price: selectedData.price,
        price1: selectedData.price1.trim().toString(),
        price2: selectedData.price2.trim().toString(),
        vendor: "",
        retailer: "",
        pageIndex: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortColumnName:
          sortColumn === "UserIPAddress"
            ? "UserIPAddress"
            : sortColumn === "vendorName"
            ? "VendorName"
            : sortColumn === "retailerName"
            ? "RetailerName"
            : sortColumn === "collectionNew"
            ? "CollectionNew"
            : sortColumn === "category"
            ? "Category"
            : sortColumn === "date"
            ? "Date"
            : sortColumn === "styleNumber"
            ? "StyleNumber"
            : sortColumn === "metalType"
            ? "MetalType"
            : sortColumn === "metalColor"
            ? "MetalColor"
            : sortColumn === "price"
            ? "Price"
            : "date",
        sortOrder: "asc",
        reporttype: "Dealer",
      };
      setDownloadCSVDataloading(true);
      ReportJewelryReportService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_JewelryPriceReport_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select" && name === "vendors") {
      let vId = "";
      if (e.includes(0)) {
        vId = [0];
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: vId,
        }));
      } else {
        vId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: e,
        }));
      }

      if (e.length === 0 || e.includes(0)) {
        handleGetVendorDropdownData();
        handleGetRetailerDropdownData();
      } else {
        changeRetailerListHandler(vId);
      }
    } else if (isSelect === "select" && name === "retailers") {
      let rId = "";
      if (e.includes(0)) {
        rId = [0];
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: rId,
        }));
      } else {
        rId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: e,
        }));
      }

      if (e.length === 0 || e.includes(0)) {
        handleGetVendorDropdownData();
        handleGetRetailerDropdownData();
      } else {
        changeVendorListHandler(rId);
      }
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order === "descend") {
      type = "DESC";
      column = sorter.field;
      setsortOrderType(type);
    } else if (sorter.order === "ascend") {
      type = "ASC";
      column = sorter.field;
      setsortOrderType(type);
    } else {
      type = "DESC";
      column = "date";
      setsortOrderType(type);
    }
    const forDealerValue =
      loginDetials?.loginDetials?.responseData?.dealerMemberTypeName === "Vendor"
        ? 1
        : 3;
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetTableChartData(
      dealerId,
      forDealerValue,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  const changeRetailerListHandler = (data) => {
    try {
      data = data.toString();
      let inputData = {
        vendorIds: data,
      };
      ReportJewelryReportService.ChangeRetailerList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setRetailerList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const changeVendorListHandler = (data) => {
    try {
      data = data.toString();
      let inputData = {
        retailerIds: data,
      };
      ReportJewelryReportService.ChangeVendorList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setVendorList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = googleChartData[selectedItem.row + 1][0];
      const value = googleChartData[selectedItem.row + 1][1];
      const result = label.split(" (")[0];

      let low, high;

      if (result !== "Call For Price") {
        [low, high] = result.split("-");

        const lowPrice1 = parseInt(low.replace("$", ""));
        const hignPrice2 = parseInt(high.replace("$", ""));

        setSelectedData((prevState) => ({
          ...prevState,
          price: "",
          price1: lowPrice1,
          price2: hignPrice2,
        }));
      } else {
        setSelectedData((prevState) => ({
          ...prevState,
          price: "Call For Price",
          price1: "",
          price2: "",
        }));
      }

      setPageNo(1);
    }
  };

 

  // Chart options
  const chartOptions = {
    is3D: true,
    pieSliceText: "percentage",
    chartArea: { width: "100%", height: "100%" },
    legend: {
      position: "none", // Hide default legend since we have custom one
    },
    colors: colorData,
    tooltip: { isHtml: true },
  };

const handleDownloadPieChart = async () => {
    try {
      // ------------ 1. High-Res Chart Setup -----------------
      const pdfChartOptions = {
        ...chartOptions,
        width: 1800,
        height: 950,
        chartArea: { left: 50, top: 140, width: "100%", height: "100%" },
        legend: { position: "none" },
        pieHole: 0.4,
        pieSliceText: "percentage",
        tooltip: { text: "percentage" },
        pieSliceTextStyle: { fontSize: 18, color: "#000" },
      };

      // ------------ 2. Hidden DOM Container -----------------
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-piechart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // ------------ 3. Custom Legends -----------------
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "flex-start";
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      googleChartData.slice(1).forEach((row, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "16px";
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = colorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
        const valueText = ` (${row[1]})`;

        const textNode = document.createTextNode(labelText + valueText);
        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // ------------ 4. Draw Chart -----------------
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "900px";
      hiddenContainer.appendChild(chartDiv);

      const tempChart = new window.google.visualization.PieChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(googleChartData);

      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // ------------ 5. Convert to Canvas -----------------
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");
      document.body.removeChild(hiddenContainer);

      // ------------ 6. Setup PDF -----------------
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;

      // ------------ 7. Header -----------------
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("JEWELRY PRICE REPORT", pageWidth - margin, 11, {
        align: "right",
      });

      // ------------ 8. Dynamic Info Block -----------------

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const normalizeIds = (arr) => arr.map((id) => Number(id));
      const vendorIds = normalizeIds(selectedData.vendorIds);
      const retailerIds = normalizeIds(selectedData.retailerIds);

      const selectedVendorNames =
        vendorIds.length === 0
          ? "All Vendors"
          : vendorList
            .filter((v) => vendorIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const selectedRetailerNames =
        retailerIds.length === 0
          ? "All Retailers"
          : retailerList
            .filter((v) => retailerIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(selectedData.fromDate).format(
        "MMM DD, YYYY"
      )} - ${moment(selectedData.toDate).format("MMM DD, YYYY")}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        ...(loginDetials.loginDetials.responseData.dealerMemberTypeName === "Admin"
          ? [
            `Vendors: ${selectedVendorNames}`,
            `Retailers: ${selectedRetailerNames}`
          ]
          : loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
            ? [`Retailers: ${selectedRetailerNames}`]
            : [`Vendors: ${selectedVendorNames}`]
        ),
        `Total Clicks: ${totalCount}`
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // split text dynamically
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // ------------ 9. Insert Chart Below Dynamic Text -----------------

      const imgRatio = canvas.width / canvas.height;
      const availableHeight = pageHeight - currentY - footerHeight - 5;

      let imgWidthMM = pageWidth - margin * 2;
      let imgHeightMM = imgWidthMM / imgRatio;

      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        currentY,
        imgWidthMM,
        imgHeightMM,
        undefined,
        "FAST"
      );

      // ------------ 10. Footer -----------------

      pdf.setFillColor(31, 38, 62);
      pdf.rect(
        0,
        pageHeight - footerHeight,
        pageWidth,
        footerHeight,
        "F"
      );

      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);

      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;

      pdf.text(footerText, pageWidth / 2, pageHeight - 5, {
        align: "center",
      });

      // ------------ 11. Watermark -----------------

      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
      pdf.restoreGraphicsState();

      // ------------ 12. SAVE -----------------

      pdf.save("Jewelry-Price-Report.pdf");

    } catch (err) {
      console.error("Error generating Jewelry Category PDF:", err);
    }
  };




  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 className="workarea__heading mt-0 mb-0">
                {t("Jewelry Price Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>

          {dealerMembershipType === "Vendor" ||
          dealerMembershipType === "VendorDiamond" ? null : (
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Vendor(s)")} </label>
                <Select
                  className="border__grey"
                  showSearch
                  mode="multiple"
                  showArrow
                  placeholder={t("Select One or More Vendors")}
                  optionFilterProp="children"
                  value={selectedData.vendorIds}
                  onChange={(e) => handleOnChange(e, "select", "vendors")}
                >
                  {vendorList.map((item, key) => {
                    return (
                      <Option key={item.dealerID} value={item.dealerID}>
                        {item.dealerCompany}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          )}

          {dealerMembershipType === "Retailer" ? null : (
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Retailer(s)")} </label>
                <Select
                  showSearch
                  showArrow
                  className="border__grey"
                  placeholder={t("Select one or more retailer ")}
                  optionFilterProp="children"
                  onChange={(e) => handleOnChange(e, "select", "retailers")}
                  notFoundContent={t("No Data Found")}
                  mode="multiple"
                  value={selectedData.retailerIds}
                >
                  {retailerList.map((item, key) => {
                    return (
                      <Option key={key} value={item.dealerID}>
                        {item.dealerCompany}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          )}

          <div className="col-md-4 mt-4">
            <div className="input__block">
              <button className="primary-btn mt-2" onClick={handleApplyFilter}>
                {t("Apply Filter")}
              </button>
            </div>
          </div>
          <div className="col-lg-12 col-md-6">
            <div className="input__block">
              <label>
                <b>
                  {" "}
                  {t("Total Jewelry Clicks")} : {totalCount}{" "}
                </b>
                <Tooltip
                  placement="right"
                  title={t(
                    "Displays the total number of jewelry clicks through the currently specified date range above"
                  )}
                >
                  <img src={UnionIcon} alt="" />
                </Tooltip>
              </label>
            </div>
          </div>
          {!showChart ? (
            <Spin spinning={showLoader}>
              <div className="col-lg-12">
                <div
                  className="chart__section"
                  style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                >
                  {googleChartData.length > 1 ? (
                    <>
                      {/* ✅ Custom Legend - ABOVE THE CHART */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          marginBottom: "10px",
                        }}
                      >
                        {googleChartData.slice(1).map((row, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              margin: "4px 8px",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                          >
                            <div
                              style={{
                                width: "14px",
                                height: "14px",
                                backgroundColor: colorData[index],
                                marginRight: "6px",
                                borderRadius: "3px",
                              }}
                            ></div>
                            <span title={row[0].replace(/\s*\([^)]*\)\s*/g, "")}>
                              {row[0].replace(/\s*\([^)]*\)\s*/g, "")}
                            </span>
                            <span style={{ marginLeft: "4px", color: "#666" }}>
                              ({row[1]})
                            </span>
                          </div>
                        ))}
                      </div>

                      {/* ✅ Centered Chart - BELOW LEGENDS */}
                      <div id="pdf-content">
                        <Chart
                          chartType="PieChart"
                          data={googleChartData}
                          options={chartOptions}
                          width={window.innerWidth > 500 ? 800 : 300}
                          height={window.innerWidth > 500 ? 500 : 300}
                          chartEvents={[
                            {
                              eventName: "select",
                              callback: handleClick,
                            },
                          ]}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="no-report-render">
                      <div className="desc-space">
                        <h4 className="text-center">{t("No Data Found")}</h4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Spin>
          ) : (
            <div className="no-report-render">
              <div className="desc-space">
                <h4 className="text-center">{t("No Data Found")}</h4>
              </div>
            </div>
          )}

          <div className="col-lg-12 mt-3 d-flex flex-end mb-3">
            {googleChartData?.length > 1 && (
              <Button className="primary-btn" onClick={handleDownloadPieChart}>
                {" "}
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            )}
            <Button
              className="primary-btn ml-2"
              onClick={() => handleExportToCSV()}
              loading={downloadCSVDataloading}
            >
              {" "}
              <i className="fa fa-download"></i> {t("Download CSV")}
            </Button>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="table__scroll">
              <Table
                className="pendjewelreq__tbl"
                scroll={{ y: "calc(100vh - 340px)" }}
                columns={[
                  {
                    title: (
                      <Tooltip title={t("Product Image")}>
                        {t("Product Image")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "imagePathNew",
                    render: (item, data) => (
                      <>
                        {data.imagePathNew ? (
                          <span
                            onClick={() => imageClickHandler(data.imagePathNew)}
                          >
                            <img
                              src={data.imagePathNew}
                              alt="img"
                              className="product__img"
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        ) : (
                          <span onClick={() => setDefaultVisible(true)}>
                            <img
                              src={DefaultImage}
                              alt="img"
                              className="product__img"
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        )}
                      </>
                    ),
                  },
                  {
                    title: (
                      <Tooltip title={t("User IP Address")}>
                        {t("User IP Address")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "userIPAddress",
                    sorter: (a, b) => {},
                  },
                  ...(dealerMembershipType !== "Vendor" &&
                  dealerMembershipType !== "VendorDiamond"
                    ? [
                        {
                          title: (
                            <Tooltip title={t("Vendor")}>{t("Vendor")}</Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "vendorName",
                          sorter: (a, b) => {},
                        },
                      ]
                    : []),
                  ...(dealerMembershipType !== "Retailer"
                    ? [
                        {
                          title: (
                            <Tooltip title={t("Retailer")}>
                              {t("Retailer")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "retailerName",
                          sorter: (a, b) => {},
                        },
                      ]
                    : []),
                  {
                    title: (
                      <Tooltip title={t("Collection")}>
                        {t("Collection")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "collectionNew",
                    sorter: (a, b) => {},
                  },
                  {
                    title: (
                      <Tooltip title={t("Category")}>{t("Category")}</Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "category",
                    sorter: (a, b) => {},
                  },
                  {
                    title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "date",
                    defaultSortOrder: "descend",
                    sorter: (a, b) => {},
                    render: (row, item) => {
                      if (Object.keys(item.date).length !== 0) {
                        return (
                          <React.Fragment>
                            <span>
                              {moment(item.date).format(
                                "MM-DD-YYYY, hh:mm:ss A"
                              )}
                            </span>
                          </React.Fragment>
                        );
                      }
                    },
                  },
                  {
                    title: (
                      <Tooltip title={t("Style Number")}>
                        {t("Style Number")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "styleNumber",
                    sorter: (a, b) => {},
                  },
                  {
                    title: (
                      <Tooltip title={t("Metal Type")}>
                        {t("Metal Type")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "metalType",
                    sorter: (a, b) => {},
                  },
                  {
                    title: (
                      <Tooltip title={t("Metal Color")}>
                        {t("Metal Color")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "metalColor",
                    sorter: (a, b) => {},
                  },
                  {
                    title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "price",
                    sorter: (a, b) => {},
                  },
                ]}
                pagination={{
                  size: "small",
                  total: totalCount,
                  pageNo: pageNo,
                  pageSize: pageSize,
                  pageSizeOptions: [10, 15, 20, 50, 100],
                  responsive: true,
                  showSizeChanger: true,
                  current: pageNo,
                }}
                loading={showTableLoader}
                dataSource={JewelryPriceTableList}
                onChange={handleTableASCDES}
              />
            </div>
          </div>
          <Modal
            title=""
            centered
            visible={visible}
            onOk={() => setVisible(false)}
            onCancel={() => setVisible(false)}
            width={500}
            footer={false}
            className="image-modal"
          >
            <div className="">
              <img src={selectedImage} alt="img" className="img-fluid" />
            </div>
          </Modal>

          <Modal
            title=""
            centered
            visible={defaultVisible}
            onOk={() => setDefaultVisible(false)}
            onCancel={() => setDefaultVisible(false)}
            width={500}
            footer={false}
          >
            <div className="">
              <img src={DefaultImage} alt="img" className="img-fluid" />
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default JewelryPriceReportMain;